import _ from 'lodash'
import { computed, inject } from 'vue'
import { useStore } from 'vuex'

import models from '@/data/models.json'

export function useUnit () {
  const store = useStore()
  const axios = inject('axios')

  const units = computed(() => _.values(_.merge(
    _.keyBy(store.state.unit.units, 'UnitNumber'),
    _.keyBy(store.state.setting.units, 'UnitNumber'),
  )))
  const compares = computed(() => store.state.compare.units)
  const compareCount = computed(() => store.getters['compare/count'])

  const statusLabel = [
    'available',
    'sold',
    'sold',
    'hold',
    '',
    '',
    'sold',
  ]

  const loadUnit = async () => {
    const { data } = await axios.post('/GetUnit')

    store.commit('unit/set', data.data)
  }

  const getUnit = (unitNumber) => {
    const unit = units.value.find(unit => unit.UnitNumber === unitNumber)

    if (unit) {
      return {
        ...unit,
        model: models.find(model => model.id === unit.ModelID),
      }
    }

    return {
      model: {},
    }
  }

  const getStatus = (unitNumber) => {
    const unit = getUnit(unitNumber)

    if (!unit.UnitStatus) {
      return ''
    }

    if (unit.DemoUnit) {
      return 'demo'
    }

    return statusLabel[parseInt(unit._UnitStatus || unit.UnitStatus)]
  }

  const hasStatus = (name, unitNumber) => {
    const unit = getUnit(unitNumber)

    if (!unit.UnitStatus) {
      return false
    }

    if (unit.DemoUnit) {
      return 'demo'
    }

    return name === statusLabel[parseInt(unit.UnitStatus)]
  }

  const hasCompare = (unitNumber) => {
    return compares.value.includes(unitNumber)
  }

  const toggleCompare = unitNumber => {
    if (hasCompare(unitNumber)) {
      store.commit('compare/remove', unitNumber)
    } else {
      store.commit('compare/add', unitNumber)
    }
  }

  return {
    units,
    models,
    compares,
    compareCount,
    loadUnit,
    getUnit,
    getStatus,
    toggleCompare,
    hasCompare,
    hasStatus,
  }
}

export const UNIT_STATUS = {
  STATUS_AVAILABLE: ['0'],
  STATUS_SOLD: ['1', '2', '6'],
  STATUS_HOLD: ['3'],
}
